<template>
  <div class="container card mt-5">
    <div v-if="!paymentSuccessed">
      <transition name="slide-left" mode="out-in">
        <div class="card-body p-md-5" key="name" v-if="!amountSelected">
          <div class="row">
            <div class="col-md">
              <div class="row">
                <div class="col-md-12 mb-2">
                  <h6>Quiero regalar Ketarim con una frecuencia:</h6>
                </div>
                <div class="col-6 mb-3">
                  <button
                    class="btn shadow btn-lg btn-block"
                    :class="[!donor.one_month? 'btn-primary':'btn-outline-light']"
                    @click="planMode('monthly')"
                  >Mensual</button>
                </div>
                <div class="col-6 mb-3">
                  <button
                    class="btn shadow btn-lg btn-block"
                    :class="[donor.one_month == true? 'btn-primary':'btn-outline-light']"
                    @click="planMode('oneTime')"
                  >Pago único</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-2 mt-3">
                  <h6>
                    Quiero regalar Ketarim por un valor de:
                  </h6>
                </div>
                <div class="col-6 col-md-4 mb-3" v-for="(amount, index) in amounts">
                  <button
                    class="btn shadow btn-lg btn-block"
                    @click="selectPlan(amount)"
                    :class="[donor.amount == amount.amount? 'btn-primary':'btn-outline-light']"
                  >USD {{amount.amount}}</button>
                </div>
              </div>
              <input
                type="text"
                class="form-control form-control-lg"
                placeholder="O ingresa el importe deseado"
                v-model="customAmount"
              />
              <div v-if="donor.one_month == true">
                <h6 class="mt-4">
                  Quiero pagar en:
                  <select name="months" id="months" v-model="donor.months">
                    <option v-for="month in months" :key="month" :value="month">{{month}}</option>
                  </select>
                  cuotas mensuales
                </h6>
                <div class="text-muted">
                  Se debitarán ${{donor.amount/donor.months}} por mes durante {{donor.months}} meses.
                </div>
              </div>
              <button class="btn btn-secondary btn-lg btn-block btn-rounded mt-5 p-3" @click="amountSelected = !amountSelected">{{buttonLabel}}</button>
            </div>
            <div class="col-md">
              <div
                class="ketarim-container"
                :style="{backgroundImage: 'url(' + require('../assets/images/regala-crown.svg')+')'}"
              >
                <div class="label">Vale por {{crownAmount(donor.amount)}} Ketarim</div>
              </div>
              <p
                class="text-primary"
                style="margin: 0 40px;"
              >Con tu regalo, cientos de yehudim de todo el mundo podrán acceder cada mes a ¡<b>{{crownAmount(donor.amount)}}</b> horas de clases! Antes de iniciar la clase, te enviarán su agradecimiento por tu acto de Jesed.</p>
            </div>
          </div>
        </div>
      </transition>
      <transition name="slide-left" mode="out-in">
        <div class="card-body p-5" key="card" v-if="amountSelected">
          <h5 class="font-weight-light">Completa tu pago</h5>
          <div class="row">
            <div class="col-md">
              <h6 class="text-muted">Datos de contacto</h6>
                <div class="form-group">
                  <label for="email">E-mail</label>
                  <input v-model="donor.email" type="email" id="email" placeholder="Escribe tu dirección de correo electrónico" class="form-control">
                </div>
                <div class="form-group">
                  <label for="phone">Teléfono</label>
                  <input id="phone" type="text" placeholder="Incluye prefijo de país y de área" class="form-control">
                </div>
                <h6 class="text-primary">
                  Vas a regalar USD {{displayAmount}} <span v-if="!donor.one_month">/mes</span>
                  <br>
                <button class="btn btn-info btn-sm" @click.prevent="amountSelected = !amountSelected">Volver al paso anterior</button>
                </h6>
            </div>
            <div class="col-md">
              <h6 class="text-muted">Datos de TARJETA</h6>
                <div class="form-group">
                  <label for="card-name">Titular</label>
                  <input v-model="donor.name" type="text" id="card-name" placeholder="Nombre completo tal como figura en la tarjeta" class="form-control">
                </div>
                <div class="form-group">
                  <label for="card-number">Número de tarjeta</label>
                  <input v-model="donor.card_number" id="card-number" type="text" placeholder="0000 0000 0000 0000" class="form-control">
                </div>
                <div class="form-row">
                  <div class="form-group col-md-3">
                    <label for="card-month">Vencimiento</label>
                    <input v-model="donor.exp_month" id="card-month" type="text" placeholder="mes" class="form-control">
                  </div>
                  <div class="form-group col-md-3">
                    <label for="card-year">&nbsp;</label>
                    <input v-model="donor.exp_year" id="card-year" type="text" placeholder="año" class="form-control">
                  </div>
                  <div class="form-group col-md-4">
                    <label for="card-cvv">CVV</label>
                    <input v-model="donor.cvv" id="card-cvv" type="text" placeholder="CVV" class="form-control">
                    <small style="font-size: 10px;line-height: 10px!important;">código de 3 o 4 números situado en el reverso de la tarjeta de crédito</small>
                  </div>
                </div>
            </div>
          </div>
          <div class="text-center mt-3 mb-3 ">
            <div class="alert alert-danger" v-if="errorMessage">
              {{errorMessage}}
            </div>
            <button @click="process" class="btn btn-secondary btn-lg btn-rounded py-3 px-5" :disabled="buttonDisable">{{buttonLabel}}</button>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="paymentSuccessed">
      <h1 class="text-center mt-10 mb-10">¡Muchas gracias!</h1>
    </div>
  </div>
</template>

<script>
import DonationsDedication from "./DonationsDedication";
import http from "../services/axios";

export default {
  name: "dedication-root-component",
  components: {
    DonationsDedication,
  },
  data: function () {
    return {
      step: 0,
      processing: false,
      amountSelected: false,
      donor: {
        months: 99,
        amount: 52,
        email: "",
        phone: "",
        name: "",
        card_number: "",
        exp_month: "",
        exp_year: "",
        cvv: "",
        one_month: false,
        reservation_id: 0,
        dedicationType: "",
        dedicateLabel: "",
        dedicationName: "",
        dedicationAnonymous: false,
      },
      options: {
        dotSize: 25,
        width: "100%",
        height: 7,
        min: 5,
        max: 1000,
        interval: 1,
        clickable: true,
        duration: 0.5,
      },
      paymentSuccessed: false,
      customAmount: null,
      errorMessage: "",
      amounts: [],
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
    };
  },
  watch: {
    customAmount: function (val, oldVal) {
      this.donor.amount = this.customAmount;
    },
  },
  created() {
    this.amounts = monthlyAmounts()
  },
  computed: {
    displayAmount () {
      if(this.donor.one_month){
        return this.donor.amount / this.donor.months + ' por mes durante ' + this.donor.months + ' meses'
      } else {
        return this.donor.amount
      }
    },
    buttonLabel() {
      if (this.step == 0 && !this.amountSelected) {
        return "Regalar ahora";
      } else if (this.processing) {
        return "Procesando...";
      } else if (this.amountSelected) {
        return "Procesar pago";
      }
    },
    buttonDisable() {
      if (
        this.processing ||
        this.selectedAmount == false ||
        (
          (this.donor.name == "" ||
            this.donor.email == "" ||
            this.donor.card_number == "" ||
            this.donor.exp_month == "" ||
            this.donor.exp_year == "" ||
            this.donor.cvv == ""))
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    selectPlan(amount) {
      this.selectedAmount = amount;
      this.customAmount = null;
      this.donor.amount = amount.amount;
    },
    crownAmount(amount) {
      if (amount < 5) {
        return 0;
      }
      if (!this.donor.one_month) {
        return amount
      } else {
        var base = 5;
        if (amount > base && amount < 200) {
          return Math.ceil(amount / base);
        } else if (amount >= 200 && amount < 500) {
          return Math.ceil(amount / (base * 0.6));
        } else if (amount >= 500 && amount < 1000) {
          return Math.ceil(amount / (base * 0.3));
        } else if (amount >= 1000) {
          return Math.ceil(amount / (base * 0.2));
        }
      }
    },
    forward() {
      if (this.buttonDisable) {
        return;
      }
      if (this.step == 1) {
        this.process();
      } else if (this.step == 2) {
        this.processDedication();
      } else {
        this.step++;
      }
    },
    process() {
      this.donor.crowns = parseInt(
        this.crownAmount(this.donor.amount)
      );
      this.$nextTick(() => {
        if(this.donor.one_month){
          this.donor.one_month_amount = (this.donor.amount / this.donor.months)
        }
      })
      this.processing = true;
      this.errorMessage = "";
      http
        .postPayment("process_payment", this.donor)
        .then((results) => {
          this.step++;
          this.donor.reservation_id = results.data.reservation_id;
          this.processing = false
          this.paymentSuccessed = true
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message;
          this.processing = false;
        });
    },
    processDedication() {
      this.errorMessage = "";
      http
        .postPayment("dedicate", this.donor)
        .then((results) => {
          this.step++;
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message;
          this.processing = false;
        });
    },
    rewind() {
      this.step--;
    },
    planMode (mode) {
      let self = this
      switch (mode) {
        case 'oneTime':
          self.amounts = oneTimeAmounts()
          this.$nextTick(() => {
            self.donor.one_month = true
            self.donor.months = 1
            self.donor.amount = 50
          })
          break;
        case 'monthly':
          self.amounts = monthlyAmounts()
          this.$nextTick(() => {
            self.donor.one_month = false
            self.donor.months = 99
            self.donor.amount = 18
          })
          break;
        default:
          break;
      }
    }
  },
};
function monthlyAmounts () {
  return [
        {
          amount: 18,
          featured: false,
        },
        {
          amount: 36,
          featured: false,
        },
        {
          amount: 52,
          featured: true,
        },
        {
          amount: 101,
          featured: false,
        },
        {
          amount: 152,
          featured: false,
        },
        {
          amount: 180,
          featured: false,
        },
      ]
}
function oneTimeAmounts () {
  return [
        {
          amount: 50,
          featured: false,
        },
        {
          amount: 100,
          featured: false,
        },
        {
          amount: 200,
          featured: true,
        },
        {
          amount: 500,
          featured: false,
        },
        {
          amount: 1000,
          featured: false,
        },
        {
          amount: 2000,
          featured: false,
        },
      ]
}
</script>
<style scoped lang="scss">
@import "../scss/main";
.ketarim-container {
  background-repeat: no-repeat;
  background-size: contain;
  padding-top: 250px;
  padding-bottom: 10px;
  .label {
    text-align: center;
    background-color: #feefd8;
    width: 330px;
    margin: auto;
    font-size: 24px;
    padding: 3px;
    font-weight: bold;
    font-size: 30px;
    line-height: 45px;
    text-align: center;
    color: #2d2ba9;
    border-radius: 40px;
    margin-bottom: 40px;
  }
}
.fade-enter-active,
.fade-leave-active{
  transition: opacity .5s
}

.fade-enter,
.fade-leave-to{
  opacity: 0
}
.btn.shadow{
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)!important;
}
#months{
  background: #2D2BA9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 18px;
  color: #fff;
  padding: 6px 10px;
}
@media (max-width: 544px) {
  .ketarim-container{
    padding-top: 160px;
    margin-top: 30px;
    .label{
      width: 100%;
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 10px;
    }
  }
}
</style>
